import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";

export function langForFilename(filename = "") {
  const f = filename.toLowerCase();
  if (f.endsWith(".py")) return "python";
  if (f === "skill.md" || f.endsWith(".md") || f.endsWith(".markdown")) return "markdown";
  if (f.endsWith(".json")) return "json";
  if (f.endsWith(".sh") || f.endsWith(".bash")) return "bash";
  if (f.endsWith(".js") || f.endsWith(".jsx")) return "javascript";
  if (f.endsWith(".ts") || f.endsWith(".tsx")) return "typescript";
  if (f.endsWith(".yml") || f.endsWith(".yaml")) return "yaml";
  if (f.endsWith(".html")) return "markup";
  if (f.endsWith(".css")) return "css";
  if (f.endsWith(".toml")) return "toml";
  return "markdown";
}

const customStyle = {
  margin: 0,
  padding: "16px 18px",
  background: "var(--rb-code)",
  fontSize: "12.5px",
  lineHeight: "1.65",
  fontFamily: "var(--font-mono)",
  minHeight: "100%", // fill the scroll area so short files don't leave a bare seam under the code
};

export const CodeBlock = ({ code = "", language = "markdown", showLineNumbers = false }) => (
  <SyntaxHighlighter
    language={language}
    style={oneDark}
    customStyle={customStyle}
    showLineNumbers={showLineNumbers}
    wrapLongLines={false}
    codeTagProps={{ style: { fontFamily: "var(--font-mono)" } }}
  >
    {code || ""}
  </SyntaxHighlighter>
);
